const CampaignListView = () => import("../presentation/views/CampaignListView.vue");
const CampaignDetailView = () => import("../presentation/views/CampaignDetailView.vue");
const ActionEditorView = () => import("../presentation/views/ActionEditorView.vue");
const ActionContentEditorView = () => import("../presentation/views/ActionContentEditorView.vue");
const DonationPageActionEditorView = () => import("../presentation/views/DonationPageActionEditorView.vue");
const CommunicationProvidersConfigView = () => import("../presentation/views/CommunicationProvidersConfigView.vue");
// Sub-section components — rendered via the CampaignDetailView layout's <router-view> so each
// sub-section owns a URL (bookmarkable, browser-navigable). Lazy-loaded per section.
const CampaignStrategySection = () => import("../presentation/components/CampaignStrategySection.vue");
const CampaignAudienceSection = () => import("../presentation/components/CampaignAudienceSection.vue");
const CampaignPlanPickerView = () => import("../presentation/views/CampaignPlanPickerView.vue");
const CampaignCommunicationSection = () => import("../presentation/components/CampaignCommunicationSection.vue");
const CampaignAnalyticsSection = () => import("../presentation/components/CampaignAnalyticsSection.vue");
const CampaignPilotageSection = () => import("../presentation/components/CampaignPilotageSection.vue");
const CampaignStatisticsSection = () => import("../presentation/components/CampaignStatisticsSection.vue");
export const campaignsRoutes = [
    {
        path: "/communication",
        name: "CampaignsList",
        component: CampaignListView,
        meta: { requiresAuth: true, titleKey: "campaigns.title" },
    },
    {
        // Parent layout. Name kept as `CampaignDetail` — external callers route here by name
        // (ActionEditorView, finance DonationTab*, NewCampaignModal) or by path. The empty child
        // redirects to the default sub-section so `/communication/:id` lands on Information.
        path: "/communication/:id",
        name: "CampaignDetail",
        component: CampaignDetailView,
        redirect: { name: "CampaignInformation" },
        meta: { requiresAuth: true, titleKey: "campaigns.title" },
        children: [
            {
                path: "information",
                name: "CampaignInformation",
                component: CampaignStrategySection,
                meta: { requiresAuth: true, titleKey: "campaignDetail.sidebar.information" },
            },
            {
                path: "audience",
                name: "CampaignAudience",
                component: CampaignAudienceSection,
                meta: { requiresAuth: true, titleKey: "campaignDetail.sidebar.audience" },
            },
            {
                path: "communication-plan",
                name: "CampaignCommunicationPlan",
                component: CampaignPlanPickerView,
                meta: { requiresAuth: true, titleKey: "campaignDetail.sidebar.communicationPlan" },
            },
            {
                path: "communication-actions",
                name: "CampaignCommunicationActions",
                component: CampaignCommunicationSection,
                meta: { requiresAuth: true, titleKey: "campaignDetail.sidebar.communicationActions" },
            },
            // The per-action Report is the only route left that takes over the canvas: `fullScreen`
            // tells CampaignDetailView to skip the assistant shell entirely, and the page owns its own
            // chrome (contextual navbar + gutter). Pilotage and Statistiques used to declare it too;
            // the V2 layout (Figma 27581:28300) puts them under the SAME campaign header as Édition,
            // as the third and second tabs of one strip, so they are ordinary children again.
            // `requiresSentCampaign`: nothing to show before the first send; `requiresSavedCampaign`:
            // Pilotage only needs the campaign information (OP-8549). CampaignDetailView bounces a
            // deep-link back to the edition flow while the matching gate is shut.
            {
                path: "report",
                name: "CampaignReport",
                component: CampaignAnalyticsSection,
                meta: {
                    requiresAuth: true,
                    fullScreen: true,
                    requiresSentCampaign: true,
                    titleKey: "analytics.title",
                },
            },
            {
                path: "pilotage",
                name: "CampaignPilotage",
                component: CampaignPilotageSection,
                meta: {
                    requiresAuth: true,
                    requiresSavedCampaign: true,
                    titleKey: "campaignDetail.pilotage.tabs.pilotage",
                },
            },
            {
                path: "statistics",
                name: "CampaignStatistics",
                component: CampaignStatisticsSection,
                meta: {
                    requiresAuth: true,
                    requiresSentCampaign: true,
                    titleKey: "campaignDetail.pilotage.tabs.statistics",
                },
            },
        ],
    },
    {
        path: "/communication/:id/actions/:actionId",
        name: "ActionEditor",
        component: ActionEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "campaigns.title" },
        props: true,
    },
    {
        path: "/communication/:id/actions/:actionId/editor",
        name: "ActionContentEditor",
        component: ActionContentEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "campaigns.title" },
        props: true,
    },
    {
        path: "/communication/:id/actions/:actionId/donation-page",
        name: "DonationPageActionEditor",
        component: DonationPageActionEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "campaigns.title" },
        props: true,
    },
    {
        // Module-configuration surface, reached from the settings sidebar (avatar menu > Profil),
        // not from the campaigns navigation. `/module/*` routes are flat by convention — the
        // onboarding wizard and the provider detail are overlays over this page, not sub-routes.
        path: "/module/communication-providers",
        name: "CommunicationProvidersConfig",
        component: CommunicationProvidersConfigView,
        meta: {
            requiresAuth: true,
            requiresCapability: "opink.admin",
            titleKey: "communicationProviders.title",
        },
    },
];
export const campaignsNavigationItems = [
    {
        labelKey: "campaigns.title",
        icon: "ri-mail-send-line",
        children: [
            {
                labelKey: "campaigns.navCampaigns",
                path: "/communication",
                meta: { requiresAuth: true },
            },
        ],
    },
];
